import * as React from "react"
import PropTypes from "prop-types"
import { StaticImage } from "gatsby-plugin-image";

import * as S from './styles';

export default function FitnessItem({ name, category, link }) {
  return (
    <S.Container to={link}>
      <S.Banner />
      <S.Avatar>
        <StaticImage
          src={`../../images/avatar.png`}
          alt="Avatar fitness"
          placeholder="blurred"
          layout="fixed"
          width={105}
          height={105}
        />
      </S.Avatar>
      <h1>{name}</h1>
      <h2>{category}</h2>
    </S.Container>
  )
}

FitnessItem.propTypes = {
  name: PropTypes.string,
  category: PropTypes.string,
  link: PropTypes.string,
}

FitnessItem.defaultProps = {
  name: `[name]`,
  category: `#category`,
  link: `/`,
}